<template>
  <main>
    <div class="header">
      <router-link to="/post" class="back">
        <h1 class="chevron">&lt;</h1>
      </router-link>
    </div>
    <div class="content">
      <h2 class="title">{{title}}</h2>
      <p class="postdetail">&nbsp;&nbsp;&nbsp;&nbsp;{{text}}</p>
      <div class="footer">
        <p>{{ $t('postDetail.sincerely') }}</p>
        <p>{{date}}</p>
<!--        <p><a target="_blank" style="color: white" href="https://t.me/coinearn_org">{{ $t('postDetail.tg') }}</a></p>-->
      </div>
    </div>
  </main>

  <div v-if="loading" class="loading-overlay" >
    <div class="loading-spinner"></div>
  </div>

</template>
<script>
export default {
  name: 'PostDetail',
  data() {
    return {
      loading:false,
      date: this.$route.params.date,
      title: this.$route.params.title,
      text: this.$route.params.text,
    }
  },
  mounted(){
  },
  created() {
  },
};
</script>

<style scoped>

.header .back {
  text-decoration: none;
  color: #f0d78c;
}

.header .title {
  flex-grow: 1;
  text-align: center;
}

.content {
  padding: 22px;
  text-align: center;
  margin-top: 1rem;
  background: rgba(16, 22, 35, 0.9);
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(212, 175, 55, 0.16);
}

title {
  font-size: 1rem;
  margin-bottom: 20px;
}

p {
  font-size: 1rem;
  margin-bottom: 10px;
}

.footer {
  margin-top: 30px;
  text-align: right;
}

.navbar div {
  flex: 1;
  text-align: center;
  padding: 10px 0;
}
.postdetail{
  text-align: left;
}
.chevron{
  padding-left: 1rem;
  margin: 0;
}

</style>
